export default "__VITE_ASSET__Dcu1Z1z9__"